import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect, useRef } from 'react';
import { Icon, useCurrentBreakpoint, mediumBreakpoint, useDidMountEffect, useStaticState } from '@phishtool/ui';
import NavigationItem from './navigation-item';
import { StyledNavigationWrapper, StyledSecondaryNavLinks, StyledSecondaryNavLink } from './styled';
const Navigation = ({ isOpen }) => {
    const ref = useRef(null);
    const [staticData] = useStaticState();
    const [hasTransition, setHasTransition] = useState(false);
    const currentBreakpoint = useCurrentBreakpoint();
    useEffect(() => {
        const isSmall = !!currentBreakpoint && currentBreakpoint < mediumBreakpoint;
        setHasTransition(isSmall);
        if (!isSmall) {
            document.body.classList.remove('overflow-hidden');
            if (ref.current) {
                ref.current.setAttribute('style', '');
            }
        }
    }, [currentBreakpoint]);
    useDidMountEffect(() => {
        if (isOpen && ref.current) {
            ref.current.style.display = 'block';
            // eslint-disable-next-line @typescript-eslint/no-unused-expressions
            ref.current.offsetHeight; // this triggers a reflow
            ref.current.style.display = 'block';
            ref.current.style.transform = 'translateX(0)';
        }
        else if (ref.current) {
            ref.current.style.display = 'block';
            ref.current.style.transform = 'translateX(100%)';
        }
        return () => {
            document.body.classList.remove('overflow-hidden');
            if (ref.current) {
                ref.current.setAttribute('style', '');
            }
        };
    }, [isOpen]);
    return (
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    _jsxs(StyledNavigationWrapper, Object.assign({ ref: ref, hasTransition: hasTransition, onTransitionEnd: () => {
            document.body.classList.toggle('overflow-hidden', isOpen);
            if (!isOpen && ref.current) {
                ref.current.setAttribute('style', '');
            }
        } }, { children: [_jsx(NavigationItem, Object.assign({ iconName: "products", iconWidth: 16, largeIconWidth: 25, to: "/products", subItems: [
                    {
                        to: '/products/enterprise',
                        title: 'PhishTool Enterprise',
                        description: 'Complete phishing incident response for professional cyber security teams and managed service providers.',
                    },
                    {
                        to: '/products/community',
                        title: 'PhishTool Community',
                        description: 'Free forensic phishing analysis for individuals in the cyber security community.',
                    },
                ] }, { children: "Products" })), _jsx(NavigationItem, Object.assign({ iconName: "light-bulb", iconWidth: 11, largeIconWidth: 16, to: "/solutions", subItems: [
                    {
                        to: '/solutions/security-operations-centres',
                        title: 'Security Operations Centres',
                        description: 'Organisations are relentlessly targeted by email-born social engineering resulting in signifcant financial loss.',
                    },
                    {
                        to: '/solutions/managed-service-providers',
                        title: 'Managed Service Providers',
                        description: 'MSPs require a powerful tool to provide customers with value-added email security using threat intelligence.',
                    },
                    {
                        to: '/solutions/law-enforcement',
                        title: 'Law enforcement',
                        description: 'Agencies require the ability to forensically analyse emails in order to report on and respond to email-born fraud.',
                    },
                ] }, { children: "Solutions" })), _jsx(NavigationItem, Object.assign({ iconName: "people", iconWidth: 23, to: "/about" }, { children: "About" })), _jsx(NavigationItem, Object.assign({ iconName: "headphones", iconWidth: 14, to: "/contact" }, { children: "Contact" })), _jsx(NavigationItem, Object.assign({ iconName: "login", iconWidth: 17, to: staticData === null || staticData === void 0 ? void 0 : staticData.env.APP_HOST, desktopOnly: true }, { children: "Login" })), _jsx(NavigationItem, Object.assign({ to: `${staticData === null || staticData === void 0 ? void 0 : staticData.env.APP_HOST}/sign-up/enterprise`, mobileOnly: true }, { children: "Get a demo" })), _jsxs(StyledSecondaryNavLinks, { children: [_jsx(StyledSecondaryNavLink, Object.assign({ href: "https://twitter.com/PhishTool", target: "_blank", rel: "noreferrer" }, { children: _jsx(Icon, { name: "twitter", fill: "oxfordBlue", width: 23, height: 20 }) })), _jsx(StyledSecondaryNavLink, Object.assign({ href: "https://www.linkedin.com/company/phishtool", target: "_blank", rel: "noreferrer" }, { children: _jsx(Icon, { name: "linked-in", fill: "oxfordBlue", width: 20, height: 20 }) })), _jsxs(StyledSecondaryNavLink, Object.assign({ href: "https://trello.com/b/wnOhoSg8/phishtool-roadmap", target: "_blank", rel: "noreferrer" }, { children: [_jsx(Icon, { name: "sign-post", fill: "oxfordBlue", width: 20, height: 20 }), "Roadmap"] }))] })] })));
};
export default Navigation;
